import { createContext, useContext } from 'react';
import type { ThemeDefaultParams } from 'ag-grid-enterprise';
import type { ReactNode } from 'react';

interface Props {
  theme: Partial<ThemeDefaultParams>;
  children: ReactNode;
}

const DEFAULT_THEME = {
  wrapperBorderRadius: '0',
  borderColor: '#f0f0f0',
  cellTextColor: '#000000E0',
  fontFamily: 'PingFang SC, Microsoft YaHei, -apple-system',
  fontSize: '12px',
  accentColor: '#024FA2',
  columnBorder: true,
  headerBackgroundColor: '#FAFAFA'
};

const ConfigContext = createContext<Partial<ThemeDefaultParams> | null>(null);

export function AgConfigProvider(props: Props): JSX.Element {
  const { theme, children } = props;

  return (
    <ConfigContext.Provider value={theme ?? DEFAULT_THEME}>{children}</ConfigContext.Provider>
  );
}

export const useAgThemeParams = (): Partial<ThemeDefaultParams> | null => {
  const ctx = useContext(ConfigContext);

  return ctx;
};
